import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Auto-attach admin token header (read at request time so logout takes effect immediately).
client.interceptors.request.use((config) => {
    try {
        const token = localStorage.getItem("cedula-admin-token");
        if (token) config.headers["X-Admin-Token"] = token;
    } catch {
        /* ignore */
    }
    return config;
});

export const fetchProducts = (params = {}) =>
    client.get("/products", { params }).then((r) => r.data);

export const fetchProduct = (id) =>
    client.get(`/products/${id}`).then((r) => r.data);

export const fetchProviders = () =>
    client.get("/providers").then((r) => r.data.providers);

export const fetchReviews = (productId) =>
    client.get(`/products/${productId}/reviews`).then((r) => r.data);

export const submitReview = (productId, payload) =>
    client.post(`/products/${productId}/reviews`, payload).then((r) => r.data);

export const submitLead = (payload) =>
    client.post("/leads", payload).then((r) => r.data);

export const fetchLeads = () =>
    client.get("/leads").then((r) => r.data);

export const createProduct = (payload) =>
    client.post("/products", payload).then((r) => r.data);

export const updateProduct = (id, payload) =>
    client.put(`/products/${id}`, payload).then((r) => r.data);

export const deleteProduct = (id) =>
    client.delete(`/products/${id}`).then((r) => r.data);

export const trackApplyClick = (id) =>
    client.post(`/products/${id}/track-click`).then((r) => r.data).catch(() => null);

export const fetchAnalytics = () =>
    client.get("/analytics/summary").then((r) => r.data);

export const fetchAdminProviders = () =>
    client.get("/admin/providers").then((r) => r.data);

export const rotateProviderToken = (id) =>
    client.post(`/admin/providers/${id}/rotate-token`).then((r) => r.data);

export const updateProviderContact = (id, contact_email) =>
    client.put(`/admin/providers/${id}/contact`, { contact_email }).then((r) => r.data);

export const reseedCatalog = () =>
    client.post("/seed").then((r) => r.data);

export const formatTT = (n) => {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return "TT$" + Number(n).toLocaleString("en-TT", { maximumFractionDigits: 0 });
};
